module.exports = __webpack_public_path__ + "static/media/8.294e80c6.png";